import { 
    SERVICE_KIND_GET_REQUEST, SERVICE_KIND_GET_SUCCESS, SERVICE_KIND_GET_ERROR, 
    SERVICE_KIND_GET_BY_KEY_REQUEST, SERVICE_KIND_GET_BY_KEY_SUCCESS, SERVICE_KIND_GET_BY_KEY_ERROR, 
    SERVICE_KIND_ADD_REQUEST, SERVICE_KIND_ADD_SUCCESS, SERVICE_KIND_ADD_ERROR, 
    SERVICE_KIND_EDIT_REQUEST, SERVICE_KIND_EDIT_SUCCESS, SERVICE_KIND_EDIT_ERROR, 
    SERVICE_KIND_DELETE_REQUEST, SERVICE_KIND_DELETE_SUCCESS, SERVICE_KIND_DELETE_ERROR
} from "../constants/serviceKindConstants";

const initialState = {
    serviceKinds: [],
    serviceKind: {},
    loading: false,
    success: null,
    error: null,
    serviceKindRequestedCount: 0,
};

export const serviceKindReducer = (state = initialState, action) => {
    switch (action.type)     {
        case SERVICE_KIND_GET_REQUEST:
            return {
                ...state,
                serviceKindRequestedCount: ++state.serviceKindRequestedCount,
                loading: true,
            };
        case SERVICE_KIND_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                serviceKinds: action.payload,
                success: true,
            };
        case SERVICE_KIND_GET_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case SERVICE_KIND_GET_BY_KEY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case SERVICE_KIND_GET_BY_KEY_SUCCESS:
            return {
                ...state,
                loading: false,
                serviceKind: action.payload,
                success: true,
            };
        case SERVICE_KIND_GET_BY_KEY_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case SERVICE_KIND_ADD_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case SERVICE_KIND_ADD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case SERVICE_KIND_ADD_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case SERVICE_KIND_EDIT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case SERVICE_KIND_EDIT_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case SERVICE_KIND_EDIT_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case SERVICE_KIND_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case SERVICE_KIND_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case SERVICE_KIND_DELETE_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        default:
            return state;
    }
}
